import HomeNavbar from "../components/HomeNavbar";
import HomeFooter from "../components/HomeFooter";
import "../components/HomeHF.css";

export default function Cancellation() {
return (
    <div>
        <HomeNavbar/>

        <main class="container-pagecomp">
            
            <section>
                <h1>Cancellation &amp; Refund Policy</h1>

                <p class="updated">
                    Last Updated: May 9, 2026
                </p>
            </section>

            <section>
                <h2>1. Subscription Cancellation</h2>

                <p>
                    Users may cancel their subscription at any time.
                </p>

                <p>Cancellation will:</p>

                <ul>
                    <li>Stop future billing</li>
                    <li>
                    Keep access active until the current billing cycle ends
                    </li>
                </ul>
            </section>

            <section>
                <h2>2. Refund Policy</h2>

                <p>
                    Due to the nature of digital and AI-powered services,
                    payments are generally non-refundable.
                </p>

                <p>
                    However, refunds may be considered in cases such as:
                </p>

                <ul>
                    <li>Duplicate charges</li>
                    <li>Billing errors</li>
                    <li>Technical failures preventing service usage</li>
                </ul>
            </section>

            <section>
                <h2>3. Credit Usage</h2>

                <p>
                    Used credits are non-refundable.
                </p>

                <p>
                    Unused credits may expire based on the active subscription plan.
                </p>
            </section>

            <section>
                <h2>4. Abuse &amp; Fraud</h2>

                <p>
                    Refunds will not be issued for:
                </p>

                <ul>
                    <li>Abuse of the platform</li>
                    <li>Policy violations</li>
                    <li>Fraudulent activity</li>
                </ul>
            </section>

            <section>
                <h2>5. Contact</h2>

                <p>
                    For billing or refund requests:
                </p>

                <p>
                    <a href="mailto:creatorcommentweb@gmail.com">
                    creatorcommentweb@gmail.com
                    </a>
                </p>
            </section>
                    

        </main>

        <HomeFooter/>
    </div>
  );
}